<template>
  <gg-card height="100%" class="fill-height">
    <gg-card-header>
      Ticket Validation
      <v-icon v-if="validated" size="20" color="primary" class="mb-2 ml-1">mdi-check-circle</v-icon>
    </gg-card-header>
    <gg-card-text class="pb-2">
      <p class="body-1">
        Validating your ticket authorizes GreenGeeks to take action on your request. Click “Validate” to continue.
      </p>
      <gg-input-label>Related Service</gg-input-label>
      <v-autocomplete
        dense
        outlined
        placeholder="Select a Related Service"
        class="gg-input"
        :filter="customServiceFilter"
        v-model="serviceID"
        :items="ticketServices"
        item-value="id"
        data-vv-name="service"
        data-vv-as="Service"
        v-validate="'required'"
        :error-messages="errors.collect('service')"
      >
        <template slot="selection" slot-scope="{ item }">
          {{ item.name }}
          <span v-show="item.domain" class="ml-1">
            - {{ item.domain }}
          </span>
        </template>
        <template slot="item" slot-scope="{ item }">
          {{ item.name }}
          <span v-show="item.domain" class="ml-1">
            - {{ item.domain }}
          </span>
        </template>
      </v-autocomplete>
    </gg-card-text>
    <v-card-actions>
      <gg-btn v-if="!validated"
             class="ml-2"
             tile
             color="primary"
             :disabled="loading"
             :loading="loading"
             @click="validate">
        Validate
      </gg-btn>
    </v-card-actions>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TicketValidation',
  props: {
    ticketid: {
      type: String,
      required: true
    },
    validated: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    serviceID: '',
    loading: false,
    serviceGroups: ['Shared Hosting', 'Reseller Hosting', 'Virtual Private Server', 'Dedicated Server'],
  }),
  computed: {
    ...mapGetters(['services']),
    ticketServices () {
      return [
        { id: 0, name: 'Other' },
        ...this.services.filter(service => this.serviceGroups.includes(service.groupname))
      ]
    }
  },
  methods: {
    ...mapActions(['validateTicket', 'reportSuccess', 'reportError']),
    async validate () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      this.loading = true
      const data = {
        serviceID: this.serviceID,
        ticket_id: this.ticketid
      }
      try {
        const response = await this.validateTicket(data)
        this.reportSuccess(response)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    customServiceFilter (item, queryText, itemText) {
      const domain = item.domain.toLowerCase()
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()

      return domain.indexOf(searchText) > -1 ||
        name.indexOf(searchText) > -1
    }
  }
}
</script>
